import React from "react";

type ColumnsOffsetProps = {
  col: string;
  offset: string;
  children: React.ReactNode;
};

const ColumnsOffset: React.FC<ColumnsOffsetProps> = ({ children, col, offset }) => {
  return <div className={`sm:col-${col} sm:offset-${offset}`}>{children}</div>;
};

export default ColumnsOffset;
